import { Inbox, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { routes } from '@/lib/routes';
import { formatCompactNumber } from '@/lib/format-number';

interface InboxSummaryPanelProps {
  unreadCount?: number;
  isLoading?: boolean;
}

export function InboxSummaryPanel({ unreadCount, isLoading }: InboxSummaryPanelProps) {
  const count = unreadCount ?? 0;
  const isEmpty = !isLoading && count === 0;
  const message = isLoading && unreadCount === undefined
    ? 'Checking your inbox…'
    : isEmpty
    ? 'Nothing requires your attention'
    : `${formatCompactNumber(count)} ${count === 1 ? 'item' : 'items'} requiring attention`;

  return (
    <Link
      to={routes.operator.inbox}
      className="flex items-center gap-3 rounded-lg border border-border bg-card p-4 shadow-sm hover:bg-accent/40 transition-colors"
    >
      <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600 dark:bg-primary-900/30">
        <Inbox className="h-5 w-5" />
        {count > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-rose-500 ring-2 ring-card" />
        )}
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-foreground">Inbox</p>
        <p className="text-xs text-muted-foreground truncate">{message}</p>
      </div>
      <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
    </Link>
  );
}
